import { FAQS } from "@/mocks/content";
import Header from "@/pages/home/components/Header";
import Ticker from "@/pages/home/components/Ticker";
import Hero from "@/pages/home/components/Hero";
import DeepDive from "@/pages/home/components/DeepDive";
import Categories from "@/pages/home/components/Categories";
import LatestNews from "@/pages/home/components/LatestNews";
import SourceChain from "@/pages/home/components/SourceChain";
import Insiders from "@/pages/home/components/Insiders";
import About from "@/pages/home/components/About";
import Faq from "@/pages/home/components/Faq";
import Subscribe from "@/pages/home/components/Subscribe";
import Footer, { BackToTop } from "@/pages/home/components/Footer";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <Header />
      <main className="w-full">
        <Hero />
        <Ticker />
        <DeepDive />
        <Categories />
        <LatestNews />
        <SourceChain />
        <Insiders />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
    </>
  );
}